// Libraries
import { ChangeEventHandler } from 'react';

// Styles
import styles from './ToggleSwitch.module.css';

/**
 * @function ToggleSwitch
 * Describe the component's function
 *
 * @example
 * return (
 *   <ToggleSwitch text='' checked={false} onChange={() => false} />
 * )
 */
function ToggleSwitch({
    text,
    checked,
    onChange,
}: ToggleSwitchProps): JSX.Element {
    return (
        <label className={styles.container}>
            <input
                type="checkbox"
                value="on"
                onChange={onChange}
                defaultChecked={checked}
            />
            <div></div>
            <span>{text}</span>
        </label>
    );
}

/**
 * @interface ToggleSwitchProps
 * Describes the properties required for the ToggleSwitch component
 *
 * @property {string} text
 * @property {boolean} checked
 * @property {ChangeEventHandler} onChange
 */
export interface ToggleSwitchProps {
    text: string;
    checked: boolean;
    onChange: ChangeEventHandler<HTMLInputElement>;
}

// Exports
export default ToggleSwitch;
